export type JoinStep = "sign-in" | "loading" | "choose-plan" | "details";

export function resolveJoinStep(
  hasSession: boolean,
  plansLoading: boolean,
  planId: string | null,
  selectedPlanExists: boolean,
): JoinStep {
  if (!hasSession) return "sign-in";
  if (plansLoading) return "loading";
  if (!planId || !selectedPlanExists) return "choose-plan";
  return "details";
}
